export const defaultNotes = 'Please enter any additional notes here...';
